import { CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

interface DeleteItemModalProps {
    open: boolean;
    close: () => void;
    customStyle?: object;
    sx?: object;
}

export default function CreateReferralModal({
    open,
    close,
    sx = {},
}: DeleteItemModalProps) {

    const handleClose = (event: React.SyntheticEvent, reason: string) => {
        // Prevent closing when clicking outside the modal (backdrop)
        if (reason === 'backdropClick') {
            return;
        }
        close();
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            disableAutoFocus={true}
            aria-labelledby="customer-modal-title"
            aria-describedby="customer-modal-description"
            sx={{ ...sx }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    width: "80%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    padding: "16px",
                    borderRadius: "8px",
                    boxShadow: 24,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >

                <CircularProgress size={50} sx={{ marginBottom: "16px" }} />
                <Typography>Creating your referral... Please wait.</Typography>
            </Box>
        </Modal>
    );
}
